export default Object.freeze({
  IN_REVIEW: 'SustaLV_018',
  APPROVED: 'SustaLV_019',
  REJECTED: 'SustaLV_020',
  default: '0',
})
